import imgKanade121 from "./img-kanade12 (1).webp";
import imgKanade122 from "./img-kanade12 (2).webp";

const imgKanade12 = [imgKanade121, imgKanade122];

export default imgKanade12;
